import { useMemo } from 'react';
import { useQueryParam } from '@atlassian/jira-router';
import { useSelectedConfigTab } from '../../controllers';
import { getIsProjectOnly, getIsScrumOnly, getIsJswOnly, isValidConfigParam } from './utils';

export const LastOpenedConfigTab = ({
	configParam,
	isUserLocatedBoard,
	isKanban,
	isJsm,
}: {
	configParam: string;
	isUserLocatedBoard: boolean;
	isKanban: boolean;
	isJsm: boolean;
}) => {
	const [, setConfigParam] = useQueryParam('config');
	const { getSelectedConfigTab, setSelectedConfigTab } = useSelectedConfigTab();

	const defaultTab = 'filter';
	const selectedTab = getSelectedConfigTab();
	const lastOpenedTab = selectedTab ? JSON.parse(selectedTab) : defaultTab;

	const shouldOverride = useMemo(() => {
		if (!isValidConfigParam(configParam)) {
			return false;
		}

		return (
			(isUserLocatedBoard && getIsProjectOnly(configParam) && getIsProjectOnly(lastOpenedTab)) ||
			(isKanban && getIsScrumOnly(configParam) && getIsScrumOnly(lastOpenedTab)) ||
			(isJsm && getIsJswOnly(configParam) && getIsJswOnly(lastOpenedTab))
		);
	}, [configParam, lastOpenedTab, isJsm, isKanban, isUserLocatedBoard]);

	if (shouldOverride) {
		setConfigParam(defaultTab);
		setSelectedConfigTab(defaultTab);
	} else {
		setConfigParam(lastOpenedTab);
	}

	return null;
};
